import React, { useState, useCallback } from "react";
import {getUserByEmail} from  './utils'

const FILE_URL = "https://storage.googleapis.com/staging-incrowd/json/xccelerate-slots/file.json";

const GetSlots = () => {
    const [email, setEmail] = useState("");
    const [slots, setSlots] = useState(null);
    const [seat, setSeat] = useState(null);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const onChange = useCallback((e) => {
        setEmail(e.target.value);
        setSeat(null);
        setError("");
    }, []);


    const fetchLatestSlots = async () => {
        const cacheBustedUrl = `${FILE_URL}?v=${Date.now()}`;

        const slotsRes = await fetch(cacheBustedUrl, {
            cache: "no-store",
        });

        if (!slotsRes.ok) {
            throw new Error("Failed to fetch slots data");
        }

        return await slotsRes.json();
    };


    const handleClick = async () => {
        if (!email) return;

        try {
            setLoading(true);
            setError("");
            setSeat(null);

            const sNo = await getUserByEmail(email.toLowerCase().trim())

            // let data = await fetchLatestSlots();
            // setSlots(data);

            if (sNo === -1){
                setError("No seat found for this email");
            } else {
                setSeat(sNo);
            }


            // const result = data.find(
            //     (item) =>
            //         item.email?.toLowerCase() === email.toLowerCase().trim()
            // );

            // if (result) {
            //     setSeat(result.seat);
            // } else {
            //     setError("No seat found for this email");
            // }
        } catch (err) {
            console.error(err);
            setError("Unable to load seat data");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="grid-wrapper" style={{ overflow: "hidden" }}>
            <div className="nav">
                <img
                    className="nav-img"
                    loading="lazy"
                    src="https://cdn.prod.website-files.com/670e4ade75003c7364a3944d/68fa1f445ff902ce45ea5f48_Xcelerate%20logo.svg"
                    alt=""
                />
                <span className="info">
                    San Francisco, CA | January 25–27, 2026
                </span>
            </div>

            <div className="get-seats">
                <div className="field">Enter your Xccelerate registered email</div>
                <div className="input-wrapper">
                    <div className="input-container">
                        <input
                            type="email"
                            value={email}
                            onChange={onChange}
                            placeholder="Enter email"
                            className="email-input"
                        />
                    </div>

                    <button
                        className="get-seat-btn"
                        onClick={handleClick}
                        disabled={loading}
                    >
                        {loading ? "Checking..." : "Get Your Table No"}
                    </button>
                </div>

                {error && <span className="error">{error}</span>}

                {seat && <div className="seat-result">Seat: {seat}</div>}
            </div>
        </div>
    );
};

export default GetSlots;

